// Shared pricing maths + labels for the 1 / 3 / 6 month plans.

export const planMonths = (p) => {
  const t = String(p?.durationType || p?.duration_type || '').toLowerCase();
  const d = Number(p?.duration ?? p?.duration_value ?? 0);
  if (t === 'months') return d;
  if (t === 'year' || t === 'years') return d * 12;
  if (t === 'days' && d) return Math.round(d / 30);
  if (p?.duration_days) return Math.round(p.duration_days / 30);
  return 0;
};

export const sortPlans = (plans) =>
  [...plans].sort((a, b) => (a.order ?? 99) - (b.order ?? 99) || planMonths(a) - planMonths(b) || a.price - b.price);

export const monthlyBase = (plans) => {
  const m = plans.find((p) => planMonths(p) === 1 && p.price > 0);
  return m ? Number(m.price) : null;
};

// Savings are only shown against the real monthly plan (months × monthly price).
export const planSavings = (plan, base) => {
  const months = planMonths(plan);
  if (!base || months <= 1 || !plan.price) return null;
  const compare = Math.round(base * months);
  const save = compare - Number(plan.price);
  if (save <= 0) return null;
  return { months, compare, save, pct: Math.round((save / compare) * 100), perMonth: Math.round(Number(plan.price) / months) };
};

export const fmtKr = (n) => Number(n).toLocaleString('sv-SE').replace(/\u00a0/g, ' ');

const MONTHS = {
  sv: (n) => (n === 1 ? '1 månad' : `${n} månader`),
  ar: (n) => (n === 1 ? 'شهر واحد' : `${n} أشهر`),
  en: (n) => (n === 1 ? '1 month' : `${n} months`),
  tr: (n) => `${n} ay`,
  fa: (n) => `${n} ماه`,
  so: (n) => (n === 1 ? '1 bil' : `${n} bilood`),
  pl: (n) => (n === 1 ? '1 miesiąc' : n < 5 ? `${n} miesiące` : `${n} miesięcy`),
  es: (n) => (n === 1 ? '1 mes' : `${n} meses`),
  de: (n) => (n === 1 ? '1 Monat' : `${n} Monate`),
};
export const monthsLabel = (n, lang) => (MONTHS[lang] || MONTHS.en)(n);

const L = {
  sv: { perMonth: 'kr/mån', save: 'Spara', vs: 'jämfört med månadsplanen', cta: 'Starta din prenumeration', current: 'Din nuvarande plan', oneTime: 'Engångsbetalning – förnyas inte automatiskt', title: 'Välj din studieplan', subtitle: 'Förbered dig inför teoriprovet', included: 'Ingår i alla planer', popular: 'Mest populär', best: 'Bästa värde', redirect: 'Omdirigerar till betalning…', total: 'totalt', soon: 'Passar dig som ska skriva provet snart' },
  ar: { perMonth: 'كرون/شهر', save: 'وفّر', vs: 'مقارنة بالخطة الشهرية', cta: 'ابدأ اشتراكك', current: 'خطتك الحالية', oneTime: 'دفعة واحدة – لا يتجدد تلقائياً', title: 'اختر خطة دراستك', subtitle: 'استعد لامتحان النظري', included: 'مشمول في كل الخطط', popular: 'الأكثر شعبية', best: 'أفضل قيمة', redirect: 'جارٍ التوجيه للدفع…', total: 'إجمالي', soon: 'مناسبة لمن سيقدّم الامتحان قريباً' },
  en: { perMonth: 'kr/mo', save: 'Save', vs: 'compared with the monthly plan', cta: 'Start your subscription', current: 'Your current plan', oneTime: 'One-time payment – does not renew automatically', title: 'Choose your study plan', subtitle: 'Get ready for the theory test', included: 'Included in every plan', popular: 'Most popular', best: 'Best value', redirect: 'Redirecting to payment…', total: 'total', soon: 'For those taking the test soon' },
};
export const pricingText = (lang) => L[lang] || L.en;

// Admin-set Swedish badge texts get translated for other UI languages.
export const badgeText = (badge, lang) => {
  if (!badge) return null;
  const t = pricingText(lang);
  if (/mest popul/i.test(badge)) return t.popular;
  if (/bästa värde/i.test(badge)) return t.best;
  return badge;
};
